import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  useEffect(() => {
    document.title = 'AITA - Página no encontrada';
  }, []);

  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '40px 20px',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <h1 style={{ fontSize: '5rem', fontWeight: 800, color: '#163300', margin: 0, lineHeight: 1 }}>404</h1>
      <p style={{ fontSize: '1.2rem', color: '#4b5563', margin: '16px 0 32px' }}>
        Esta página no existe.
      </p>
      <Link
        to="/"
        style={{
          padding: '10px 24px',
          borderRadius: '999px',
          background: 'linear-gradient(135deg, #22c55e, #e1e34a)',
          color: '#052e16',
          fontWeight: 700,
          textDecoration: 'none',
          fontSize: '0.95rem',
        }}
      >
        Ir al inicio
      </Link>
    </div>
  );
}
